import React, { useId, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

type PasswordFieldProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & { label: string };

export default function PasswordField({ label, id, disabled, ...inputProps }: PasswordFieldProps) {
    const generatedId = useId();
    const inputId = id || generatedId;
    const [visible, setVisible] = useState(false);
    const action = `${visible ? 'Ocultar' : 'Mostrar'} ${label.toLowerCase()}`;
    return <div className="security-field">
        <label htmlFor={inputId}>{label}</label>
        <div className="security-password-wrap">
            <input {...inputProps} id={inputId} type={visible ? 'text' : 'password'} disabled={disabled} />
            <button type="button" className="security-password-toggle" onClick={() => setVisible(current => !current)} disabled={disabled} aria-label={action} title={action} aria-pressed={visible} aria-controls={inputId}>
                {visible ? <EyeOff size={20} aria-hidden="true" /> : <Eye size={20} aria-hidden="true" />}
            </button>
        </div>
    </div>;
}
